import { atom } from 'jotai';

export const DEFAULT_VALUE = {
  modularParentSlug: null,
  modularTotalPrice: 0,
  modularBundleOrderStatus: {},
  currentModularGalleryProduct: null,
  bundleProducts: [],
  preConfiguredProducts: [],
  modularAllPreConfigHeroGallery: [],
  modularSectionalProduct: null,
  isModularAddProductSidebarOpen: false,
  collectionTitle: '',
};

const modularPdpAtom = atom(DEFAULT_VALUE);

export default modularPdpAtom;
